import { Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Box, Container, Grid } from "@mui/material";
import axios from "axios";
import {
  AutoCompleteComponent,
  ColorPickerInput,
  CurrencyNumberInput,
  FormCard,
  FormLabel,
  FormUploadImage,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  PrimaryDeleteButton,
  SecondaryButton,
  SectionLabel,
  SelectInput,
  SkeletonComponent,
  TextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
const urlToFile = async (url, fileName) => {
  if (!url) return null;
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], fileName || "logo.png", {
      type: blob.type || "image/png",
    });
  } catch (error) {
    console.error("Error converting url to file", error);
    return null;
  }
};

const FormParameterSociety = () => {
  const classes = globalStyles();
  const history = useHistory();
  const { id } = useParams();
  const pageTitle = `${id ? "Edit" : "Add"} Society`;
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(true);
  const [optionCountry, setOptionCountry] = useState([]);
  const [optionTerritory, setOptionTerritory] = useState([]);
  const [payload, setPayload] = useState({
    society_name: "",
    is_member: 1,
    ipi_name_number: "",
    ipi_base_number: "",
    society_code: "",
    email: "",
    offcial_website_url: "",
    caris_subdomain: "",
    description: "",
    royalty: "is_pr_collection_flag",
    country_id: "",
    phone_number: "",
    address: "",
    image_logo: null,
    profile_image_url: "",
    theme_color: "#000000",
    territory_details: [
      {
        territory_id: "",
        society_fee: 0,
      },
    ],
  });
  const [societyLogo, setSocietyLogo] = useState({
    image_url: null,
    image: null,
  });

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleChangeSelectedSociety = (value, key, index) => {
    setPayload(prev => ({
      ...prev,
      territory_details: prev?.territory_details?.map((item, i) =>
        i === index ? { ...item, [key]: value } : item
      ),
    }));
  };
  const handleRemoveSociety = index =>
    setPayload(prev => ({
      ...prev,
      territory_details: prev?.territory_details?.filter((_, i) => i !== index),
    }));
  const handleAddSociety = () =>
    setPayload(prev => ({
      ...prev,
      territory_details: [
        ...prev?.territory_details,
        { territory_id: "", society_fee: 0 },
      ],
    }));

  const getOptionCountry = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/country/table`, {
        headers,
        params: {
          page: 1,
          per_page: 99,
          search: "",
          sort: "",
        },
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        label: item?.country_name,
      }));
      setOptionCountry(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getOptionTerritory = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/admin/territory`, {
        headers,
        params: { page: 1, size: -1 },
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        label: item?.territory_code,
      }));
      setOptionTerritory(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDetail = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/admin/society/${id}`, {
        headers,
      });
      const { data } = res?.data;
      const requiredKeys = [
        "society_name",
        "society_code",
        "ipi_name_number",
        "ipi_base_number",
        "country_id",
        "phone_number",
        "email",
        "address",
        "offcial_website_url",
        "caris_subdomain",
        "description",
        "theme_color",
        "territory_details",
      ];
      const filteredData = requiredKeys?.reduce((acc, key) => {
        acc[key] = data[key];
        return acc;
      }, {});
      setPayload({
        is_member: data?.is_member ? 0 : 1,
        image_logo: data?.profile_image_url,
        royalty: optionRoyaltyType.find(item => data?.[item.id] === true)?.id,
        ...filteredData,
      });
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const handleSubmit = async () => {
    const method = id ? axios.put : axios.post;
    const formData = new FormData();
    const {
      image_logo,
      territory_details,
      is_member,
      royalty,
      ...restPayload
    } = payload;
    const territory_ids = (territory_details || [])
      .map(({ territory_id }) => territory_id)
      .join(", ");
    const society_fees = (territory_details || [])
      .map(({ society_fee }) => society_fee)
      .join(", ");
    const royaltyFlags = optionRoyaltyType.reduce((acc, option) => {
      acc[option.id] = option.id === royalty;
      return acc;
    }, {});
    const modifiedPayload = {
      ...restPayload,
      ...royaltyFlags,
      is_member: Boolean(is_member === 0),
    };
    formData.append("territory_ids", territory_ids);
    formData.append("society_fees", society_fees);
    Object.entries(modifiedPayload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    let logoFile = societyLogo?.image;
    if (!logoFile && image_logo) {
      if (image_logo instanceof File) {
        logoFile = image_logo;
      } else if (typeof image_logo === "string" && image_logo.startsWith("http")) {
        const fileName =
          image_logo.substring(image_logo.lastIndexOf("/") + 1) || "logo.png";
        logoFile = await urlToFile(image_logo, fileName);
      }
    }

    if (logoFile) {
      formData.append("image_logo", logoFile);
    } else {
      formData.append("image_logo", "");
    }
    try {
      setLoadingPage(true);
      const url = `${hardBaseUrl}/admin/society${id ? `/${id}` : "/"}`;
      await method(url, formData, {
        headers,
      });
      ModalSuccess(`Succesfully ${id ? "update" : "save"} society`).then(() =>
        history.goBack()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [getOptionCountry(), getOptionTerritory()];
    if (id) {
      promises.push(getDetail());
    }

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Page className={classes?.root} title={pageTitle}>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={pageTitle}
            breadcrumbData={breadcrumbData({ pageTitle })}
            backButton
          />
          <Divider className={classes?.divider} />
          <Grid container columnSpacing={2}>
            <Grid item xs={12} md={6}>
              <SectionLabel
                title="Society Profile"
                subTitle="Input the data requirement to create the society profile"
              />
              <FormCard>
                <Grid container direction="column" rowSpacing={1}>
                  {MockFieldForm({ optionCountry }).map(
                    ({
                      key,
                      title,
                      required,
                      type,
                      endAdorment,
                      options,
                      multiline,
                      rows,
                    }) => (
                      <Grid item key={key}>
                        <FormLabel label={title} required={required} />
                        {type === "select" ? (
                          <SelectInput
                            options={options}
                            optionKey="id"
                            optionLabel="label"
                            value={payload?.[key]}
                            onChange={e =>
                              handleChangePayload(e?.target?.value, key)
                            }
                            width="100%"
                          />
                        ) : type === "autocomplete" ? (
                          <AutoCompleteComponent
                            placeholder={title}
                            options={options}
                            value={
                              options?.find(
                                option => option?.id === Number(payload?.[key])
                              ) || null
                            }
                            onChange={e => handleChangePayload(e, key)}
                            size="small"
                            width="100%"
                          />
                        ) : (
                          <TextInput
                            placeholder={title}
                            value={payload?.[key]}
                            endAdornment={endAdorment}
                            onChange={e =>
                              handleChangePayload(e?.target?.value, key)
                            }
                            multiline={multiline}
                            rows={rows}
                          />
                        )}
                      </Grid>
                    )
                  )}
                </Grid>
              </FormCard>
            </Grid>
            <Grid item xs={12} md={6}>
              <SectionLabel
                title="Appearance"
                subTitle="Choose your company logo and customize the color theme"
              />
              <FormCard>
                <FormUploadImage
                  label="Society Logo"
                  required
                  imageUrl={societyLogo.image_url || payload?.image_logo}
                  setImageLogo={setSocietyLogo}
                />
                <Box mt="16px">
                  <FormLabel label="Theme Color" />
                  <ColorPickerInput
                    value={payload?.theme_color}
                    onChange={color =>
                      handleChangePayload(color, "theme_color")
                    }
                  />
                </Box>
              </FormCard>
              <Grid container justifyContent="space-between">
                <Grid item>
                  <SectionLabel
                    title="Society Fee"
                    subTitle="Input your society fee for the data requirement"
                  />
                </Grid>
                {payload?.territory_details?.length < 5 && (
                  <Grid item>
                    <SecondaryButton
                      startIcon={<Add />}
                      label="Add Society Fee"
                      onClick={handleAddSociety}
                    />
                  </Grid>
                )}
              </Grid>
              {payload?.territory_details?.map(
                ({ territory_id, society_fee }, index) => (
                  <FormCard key={index}>
                    <Grid container direction="column" rowGap={1}>
                      <Grid item>
                        <FormLabel label="Territory" required />
                        <AutoCompleteComponent
                          options={optionTerritory}
                          value={
                            optionTerritory.find(
                              option => option.id === territory_id
                            ) || null
                          }
                          onChange={e =>
                            handleChangeSelectedSociety(
                              e,
                              "territory_id",
                              index
                            )
                          }
                          placeholder="Select Territory"
                          size="small"
                          width="100%"
                        />
                      </Grid>
                      <Grid item>
                        <FormLabel label="Society Fee" required />
                        <CurrencyNumberInput
                          value={society_fee || 0}
                          onChange={data =>
                            handleChangeSelectedSociety(
                              data > 100 ? 100 : data,
                              "society_fee",
                              index
                            )
                          }
                          endAdornment="%"
                        />
                      </Grid>
                      {payload?.territory_details?.length > 1 && (
                        <Grid container justifyContent="right" mt={1}>
                          <PrimaryDeleteButton
                            onClick={() => handleRemoveSociety(index)}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </FormCard>
                )
              )}
            </Grid>
          </Grid>
          <Grid container justifyContent="right">
            <PrimaryButton onClick={handleSubmit} label="Save" />
          </Grid>
        </Container>
      )}
    </Page>
  );
};

const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Parameter",
    link: "/admin/parameter/society",
  },
  {
    label: "Society",
    link: "/admin/parameter/society",
  },
  {
    label: pageTitle,
    active: true,
  },
];
const optionStatus = [
  {
    id: 0,
    label: "Member",
  },
  {
    id: 1,
    label: "Non-Member",
  },
];
const optionRoyaltyType = [
  {
    id: "is_pr_collection_flag",
    label: "PR Collection Share",
  },
  {
    id: "is_mr_collection_flag",
    label: "MR Collection Share",
  },
  {
    id: "is_sr_collection_flag",
    label: "SR Collection Share",
  },
];
const MockFieldForm = ({ optionCountry }) => [
  {
    title: "Profile Society Name",
    key: "society_name",
    required: true,
  },
  {
    title: "Status",
    key: "is_member",
    options: optionStatus,
    type: "select",
  },
  {
    title: "IPI Name Number",
    key: "ipi_name_number",
    required: true,
  },
  {
    title: "IPI Base Number",
    key: "ipi_base_number",
  },
  {
    title: "Transmitter Code",
    key: "society_code",
  },
  {
    title: "Email",
    key: "email",
    required: true,
  },
  {
    title: "Official Website",
    key: "offcial_website_url",
    endAdorment: ".com",
  },
  {
    title: "Subdomain",
    key: "caris_subdomain",
    endAdorment: "caris.id",
  },
  {
    title: "Royalty Type",
    key: "royalty",
    required: true,
    options: optionRoyaltyType,
    type: "select",
  },
  {
    title: "Country",
    key: "country_id",
    required: true,
    options: optionCountry,
    type: "autocomplete",
  },
  {
    title: "Phone Number",
    key: "phone_number",
    required: true,
  },
  {
    title: "Description",
    key: "description",
    multiline: true,
    rows: 2,
  },
  {
    title: "Address",
    key: "address",
    required: true,
    multiline: true,
    rows: 4,
  },
];

export default FormParameterSociety;
